import React, { lazy } from 'react';
export const CTAButton = ({
  children,
  subtext,
  scrollTo
}: {
  children: React.ReactNode;
  subtext?: string;
  scrollTo?: string;
}) => {
  const handleClick = () => {
    if (!scrollTo) return;
    const el = document.getElementById(scrollTo);
    if (!el) return;
    // Robust smooth scroll: lazy images below the fold can shift layout mid-scroll,
    // so we recompute the target position a few times until it stabilizes.
    const scrollToTarget = () => {
      const top = el.getBoundingClientRect().top + window.pageYOffset - 24;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    };
    scrollToTarget();
    // Recheck after layout/images settle
    setTimeout(scrollToTarget, 400);
    setTimeout(scrollToTarget, 900);
  };
  return <div className="flex flex-col items-center w-full max-w-xl mx-auto mt-8 mb-6" data-id="element-206">
      <button onClick={handleClick} className="w-full group relative inline-flex items-center justify-center px-8 py-5 text-lg font-bold text-white transition-all duration-200 bg-gradient-to-b from-emerald-400 to-emerald-600 border-b-4 border-emerald-800 rounded-xl hover:from-emerald-300 hover:to-emerald-500 hover:-translate-y-1 active:translate-y-0 active:border-b-0 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 focus:ring-offset-dark-900 shadow-[0_0_40px_rgba(16,185,129,0.3)] hover:shadow-[0_0_60px_rgba(16,185,129,0.5)]" data-id="element-207">
        <span className="flex items-center gap-2 text-xl tracking-wide uppercase text-shadow-sm" data-id="element-208">
          {children}
        </span>
      </button>
      {subtext && <p className="mt-3 text-sm font-medium text-gray-400 flex items-center gap-2 text-center" data-id="element-209">
          {subtext}
        </p>}
    </div>;
};